import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-add-menu-section",
    templateUrl: "./add-menu-section.component.html",
    styleUrls: ["./add-menu-section.component.scss"],
})
export class AddMenuSectionComponent implements OnInit {
    ngOnInit(): void {}
}
